@if (contextService.form) {
	<mat-expansion-panel
		[id]="item.assessableItemId"
		[class.checklistEditable]="mode === AssessablePanelMode.Edit"
		[@zoomInOnEnter]
		[@zoomOutOnLeave]
		[class.inEditMode]="inEditMode && itemControl.valid"
		[class.invalid]="itemControl.invalid"
		class="checklistItemPanel twoColorHeader"
		[expanded]="expanded"
		hideToggle
	>
		<mat-expansion-panel-header (click)="togglePanel()">
			<mat-panel-title (keydown.space)="$event.stopImmediatePropagation()">
				<div class="panelTitleWrapper">
					<div class="panelTitleContent">
						<div class="topHeader">
							<div class="index">
								<div>{{ indexOne() }}.{{ indexTwo() }}.</div>
							</div>

							@if (mode === AssessablePanelMode.Edit) {
								@if (!inEditMode) {
									<div class="typeIcon">
										@switch (item.type) {
											@case (ChecklistItemType.FreeAnswerOption) {
												<mat-icon fontSet="fad" fontIcon="fa-font-case" inline />
											}
											@case (ChecklistItemType.YesNoOption) {
												<mat-icon fontSet="fad" fontIcon="fa-toggle-on" inline />
											}
											@case (ChecklistItemType.MultipleChoiceOption) {
												<mat-icon fontSet="fad" fontIcon="fa-check-double" inline />
											}
											@case (ChecklistItemType.SingleChoiceOption) {
												<mat-icon fontSet="fad" fontIcon="fa-check" inline />
											}
											@case (ChecklistItemType.ThreeStarOption) {
												<mat-icon fontSet="fad" fontIcon="fa-star-half" inline />
											}
										}
									</div>
									<div class="typeDescription">
										{{ ChecklistItemType[item.type] | translate }}
									</div>
								}

								@if (inEditMode) {
									<mat-form-field class="itemTypeSelector" appStopPropagation color="accent">
										<mat-label>{{ T.ASSESSABLE_ITEM_CHOOSE_TYPE | translate }}</mat-label>
										<mat-select [value]="item.type" (selectionChange)="handleItemTypeChange($event.value)">
											<mat-option [value]="ChecklistItemType.MultipleChoiceOption">
												<mat-icon fontSet="fad" fontIcon="fa-check-double" inline />
												{{ T.CHANGE_TYPE_OF_CHECKLIST_ITEM_MULTIPLE_CHOICE_OPTION | translate }}
											</mat-option>
											<mat-option [value]="ChecklistItemType.SingleChoiceOption">
												<mat-icon fontSet="fad" fontIcon="fa-check" inline />
												{{ T.CHANGE_TYPE_OF_CHECKLIST_ITEM_SINGLE_CHOICE_OPTION | translate }}
											</mat-option>
											<mat-option [value]="ChecklistItemType.FreeAnswerOption">
												<mat-icon fontSet="fad" fontIcon="fa-font-case" inline />
												{{ T.CHANGE_TYPE_OF_CHECKLIST_ITEM_FREE_ANSWER_QUESTION | translate }}
											</mat-option>
											<mat-option [value]="ChecklistItemType.ThreeStarOption">
												<mat-icon fontSet="fad" fontIcon="fa-star-half" inline />
												{{ T.CHANGE_TYPE_OF_CHECKLIST_ITEM_THREE_STAR_OPTION | translate }}
											</mat-option>
											<mat-option [value]="ChecklistItemType.YesNoOption">
												<mat-icon fontSet="fad" fontIcon="fa-toggle-on" inline />
												{{ T.CHANGE_TYPE_OF_CHECKLIST_ITEM_YES_NO_OPTION | translate }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								}
							}

							<div class="orderActions">
								<ng-container *ngTemplateOutlet="scoreTemplate" />

								<ng-container *ngTemplateOutlet="dragHandleTemplate" />

								<ng-container *ngTemplateOutlet="answerBadgeTemplate" />

								@if (!hideExpandButton) {
									<button
										mat-icon-button
										color="accent"
										[matTooltip]="
											(expanded ? T.SHARED_EXPANSION_TOGGLE_CLOSE : T.SHARED_EXPANSION_TOGGLE_OPEN) | translate
										"
										matTooltipClass="accent"
										[matTooltipDisabled]="tooltipDisabled"
										appStopPropagation
										(click)="togglePanel()"
										(touchstart)="tooltipDisabled = true"
									>
										<sim-animated-material-icon
											[endIcon]="{
												fontSet: 'fad',
												fontIcon: 'fa-chevron-up',
												themeColor: 'accent',
											}"
											[startIcon]="{
												fontSet: 'fad',
												fontIcon: 'fa-chevron-down',
												themeColor: 'accent',
											}"
											[trigger]="expanded"
										/>
									</button>
								}

								@if (mode === AssessablePanelMode.Edit) {
									<button
										mat-icon-button
										color="accent"
										appStopPropagation
										[matMenuTriggerFor]="moreOptionsChecklistItem"
									>
										<mat-icon fontSet="fad" fontIcon="fa-ellipsis-v-alt" />
									</button>
								}

								<mat-menu #moreOptionsChecklistItem="matMenu">
									<ng-container *ngTemplateOutlet="menuContentTemplate" />
								</mat-menu>
							</div>
						</div>

						<div class="bottomHeader">
							@if (!inEditMode) {
								<div
									class="textNonEditMode showDotsOnOverflow"
									[class.nonEditMode]="mode !== AssessablePanelMode.Edit"
									[@zoomInOnEnter]
								>
									<sim-rich-text-editor-view [content]="itemControl.controls.title.value" />
								</div>
							} @else {
								<div class="textEditMode" appStopPropagation [stopPKeyDown]="true" [@zoomInOnEnter]>
									<mat-form-field color="accent" class="full-width-form">
										<mat-label>{{ T.ASSESSABLE_ITEM_QUESTION | translate }}</mat-label>
										<sim-rich-text-editor-control
											[placeholder]="T.ASSESSABLE_ITEM_QUESTION | translate"
											[formControl]="itemControl.controls.title"
										/>
										@if (itemControl.controls.title.hasError("required")) {
											<mat-error>
												{{ T.ASSESSABLE_ITEM_QUESTION_REQUIRED | translate }}
											</mat-error>
										}
									</mat-form-field>
								</div>
							}
						</div>
					</div>
				</div>
			</mat-panel-title>
		</mat-expansion-panel-header>

		<!-- Needs to be two if statements bcs of how content projection in mat-expansion-panel works -->
		@if (expanded) {
			<div class="checklistEntryContent" [class.disabled]="disabled">
				@switch (item.type) {
					@case (ChecklistItemType.FreeAnswerOption) {
						<ng-container *ngTemplateOutlet="freeAnswerItemTemplate" />
					}
					@case (ChecklistItemType.YesNoOption) {
						<ng-container *ngTemplateOutlet="yesNoItemTemplate" />
					}
					@case (ChecklistItemType.ThreeStarOption) {
						<ng-container *ngTemplateOutlet="ratingItemTemplate" />
					}
					@case (ChecklistItemType.MultipleChoiceOption) {
						<ng-container *ngTemplateOutlet="multipleChoiceItemTemplate" />
					}
					@case (ChecklistItemType.SingleChoiceOption) {
						<ng-container *ngTemplateOutlet="singleChoiceItemTemplate" />
					}
				}
			</div>
		}

		<!-- Needs to be two if statements bcs of how content projection in mat-expansion-panel works -->
		@if (expanded) {
			<mat-action-row
				class="flex-column bottomContent"
				[@zoomInOnEnter]
				[ngClass]="{
					hidden: mode !== AssessablePanelMode.Edit && !item.answerTime && !item.note,
				}"
			>
				<div
					class="bottomUpperContent"
					[ngClass]="{
						withPadding: mode === AssessablePanelMode.Edit || item.note,
					}"
				>
					<ng-container *ngTemplateOutlet="middleAdditionalContentTemplate" />

					<sim-note-area
						[formControl]="itemControl.controls.note"
						[mode]="mode"
						[inEditMode]="inEditMode"
						[canEnterEditMode]="canEnterEditMode"
					/>
				</div>

				<div
					class="bottomLowerContent"
					[ngClass]="{
						withPadding: item.answerTime || inEditMode,
					}"
				>
					@if (item.answerTime) {
						<div class="checklistTimeStamp center">
							<sim-timer-display [relativeTime]="item.answerTime" [startDate]="scenarioRecording?.start" />
						</div>
					}

					@if (mode === AssessablePanelMode.View && item.answerTime && isInArchive) {
						<button class="right" mat-button color="accent" (click)="onTimestampClicked.emit()">
							<mat-icon fontSet="fad" fontIcon="fa-play" inline />
							{{ T.SHARED_EXPANSION_CHECKLIST_JUMP_TO_MARKER | translate }}
						</button>
					}
				</div>
			</mat-action-row>
		}
	</mat-expansion-panel>
}
